module.exports = __webpack_public_path__ + "35bc2dcb67940e2444bde370a28cc86a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Yellow1.jpg
// module id = 13
// module chunks = 0